import React from "react";
import {useTranslation} from "react-i18next";

export default function ReviewNumberLabel(props) {
    const {value} = props;
    const {t} = useTranslation();

    return <span><strong>{value}</strong> {t("W_REVIEWS")}</span>

}